import OpenAI from 'openai';
import { generateSystemPrompt } from '../chatbot/prompts';

export const openai = new OpenAI({
  apiKey: import.meta.env.VITE_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true
});

export const SYSTEM_PROMPT = generateSystemPrompt();